export default {
    data() {
        return {
            ignoreLeaveEvent: false
        }
    },
    mounted() {
        console.log('Called PageLeaveConfirm mixin mount()');
    },
    beforeRouteLeave(to, from, next) {
        console.log('Called beforeRouteLeave!');
        console.log(this.ignoreLeaveEvent);
        if(this.dbName !== 'jpfire' || this.ignoreLeaveEvent || confirm('Are you sure you want to go back? You will lose data if you have not saved and synchronised.')) {
            next(true);
        } else {
            next(false);
        }
    }
}